<template lang="pug">
  .card-box.m-t-20
    h4.text-dark.header-title.m-b-10
      | 軽量化された画像
      span.badge.badge-primary.m-l-5
        | {{resources.length}}

    template(v-if="resources.length == 0")
      div このページに軽量化できる画像はありません。
    template(v-else)
      table.table.table-bordered
        thead
          tr
            th(width="20%")
            th(width="40%") {{ 'orig' | i18nSimulation }}
            th(width="40%") {{ 'webp' | i18nSimulation }}
        tbody
          tr
            th.text-xl 全画像の合計
            td
              div
                .text-xl.pull-left
                  Filesize(v-bind:value="sizes.orig")
            td
              div
                .text-xl.pull-left
                  Filesize(v-bind:value="reduces.webp" expectMinus)
                .text-xl.pull-right
                  Percentage(v-bind:value="reduceRates.webp" expectMinus)

          tr(v-for="(resource, idx) in imageResources")
            th
              div
                | 画像{{idx + 1}}
                = ' '
                ImageTypeBadge(v-bind:type="resource.ext")
              div
                small {{resource.hostname}}
            td
              a(v-bind:href="imageResourceUrl(resource, 'orig')" target="_blank")
                .m-b-10
                  img.img-fluid(v-bind:src="imageResourceUrl(resource, 'orig')")
                div
                  strong.pull-left
                    Filesize(v-bind:value="resource.data.orig.size")
            td
              a(v-bind:href="imageResourceUrl(resource, 'webp')" target="_blank")
                .m-b-10
                  img.img-fluid(v-bind:src="imageResourceUrl(resource, 'webp')")
                div
                  strong.pull-left
                    Filesize(v-bind:value="resourceReduced(resource, 'webp')" expectMinus)
                  strong.pull-right
                    Percentage(v-bind:value="resourceReducedRate(resource, 'webp')" expectMinus)
</template>

<script>
import Path from 'path'
import Lib from '@/lib'
import Filesize from '@/components/common/Filesize'
import Percentage from '@/components/common/Percentage'
import ImageTypeBadge from '@/components/common/ImageTypeBadge'

export default {
  components: {
    Filesize,
    Percentage,
    ImageTypeBadge,
  },
  props: {
    s3KeyBase: String,
    resources: Array,
  },
  computed: {
    imageResources: function() {
      return this.resources.filter(r => r.data && r.data.orig);
    },
    sizes: function() {
      const sizes = this.imageResources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = (sizes[key] || 0);
          sizes[key] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reduces: function() {
      const sizes = this.sizes;
      const reduces = {};
      for (let key in sizes) {
        reduces[key] = sizes[key] - sizes.orig;
      }
      return reduces;
    },
    reduceRates: function() {
      const sizes = this.sizes;
      const reduces = this.reduces;
      const rates = {};
      for (let key in sizes) {
        rates[key] = reduces[key] / sizes.orig;
      }
      return rates;
    },
    sizesByExt: function() {
      const sizes = this.imageResources.reduce((sizes, r) => {
        for (let key in r.data) {
          sizes[key] = sizes[key] || {};
          sizes[key][r.ext] = sizes[key][r.ext] || 0;
          sizes[key][r.ext] += (r.data[key].size || 0);
        }
        return sizes;
      }, {});
      return sizes;
    },
    reducesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          reduces[key] = reduces[key] || {};
          reduces[key][ext] = sizes[key][ext] - sizes.orig[ext];
        }
      }
      return reduces;
    },
    reduceRatesByExt: function() {
      const sizes = this.sizesByExt;
      const reduces = this.reducesByExt;
      const rates = {};
      for (let key in sizes) {
        for (let ext in sizes[key]) {
          rates[key] = rates[key] || {};
          rates[key][ext] = reduces[key][ext] / sizes.orig[ext];
        }
      }
      return rates;
    },
    uniqueExts: function() {
      const unique = { jpg: 0, png: 0, gif: 0 };
      this.imageResources.forEach(r => unique[r.ext]++);
      return Object.keys(unique).filter(ext => unique[ext] > 0)
    }
  },
  methods: {
    imageResourceUrl: function(resource, key) {
      const uri = Path.join(resource.s3KeyBase, resource.data[key].s3KeyPath);
      const url = new URL(uri, Lib.preset().resourceUrlBase);
      return url.href;
    },
    resourceReduced: function(resource, key) {
      return resource.data[key].size - resource.data.orig.size;
    },
    resourceReducedRate: function(resource, key) {
      return (resource.data[key].size - resource.data.orig.size) / resource.data.orig.size;
    }
  },

}
</script>